import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbars } from "react-custom-scrollbars";
import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper";
import { Link } from "react-router-dom";

// TIPPY JS
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import axios from "axios";
import "./Home.scss";
import services, { baseUrl } from "../../Common/services.jsx";
import Api from "../../Common/api.jsx";
import CommonHelper from "../../Helpers/CommonHelper.jsx";
import MetaMaskService from "../../Common/metamaskService.jsx";
import { Navigate } from "react-router-dom";
import ErrorHandler from "../../Helpers/ErrorHandler.jsx";
import { notifications } from "../../Helpers/Notifications";
import { ethers } from "ethers";
import Web3Modal from "web3modal";
import NFTMarket from "../../../artifacts/contracts/NFTMarket.sol/NFTMarket.json";
import SkeletonProduct  from "../../Pages/Skeleton/index.jsx";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.applyFilter = false;
    this.timeout = 0;
    this.timeout1 = 0;
    this.timeout2 = 0;    this.state = {
      filter: "",
      loader :false,
      loader1:false,
      loader2:false,
      loader3:false,
      loader4:false,
      accountId: null,
      account : "",
      exploreArry: [],
      topCollectionArry: [],
      topCollectioDays: [24, 7, 30],
      summaryArry: [],
      categoryArray: [],
      assetActivityArry: [],
      featureNftArry: [],
      assetCollectionArry: [],
      topCollectionStatus: "7 days",

      status: false,
      minprice: null,
      maxPrice: null,
      chain: [],
      category_id: null,
      showVerifiedOnly: false,
      pageNumber: 1,
      pageSize: 12,
      chainConfig: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getExplore();
    this.getTopcollection(null);
    this.getSummary();
    this.getPredefineCategory();
    this.getNftCollection();
    this.getNftAssetToken();
    let account = localStorage.getItem("accountId");
    if (account) {
      this.setState({ accountId: account });
    }
  }

  unCheck(i) {
    let ref = "ref_" + i;
    this.refs[ref].checked = !this.refs[ref].checked;
  }
  showMOreCollection() {
    var pageNumber = this.state.pageNumber + 1;
    this.setState({ pageNumber: pageNumber }, () => {
      this.getExplore();
    });
  }
  handleChange(e) {
    console.log(e, e.target.name);
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  }

  handleChangeCheck = (e) => {
    this.setState({ status: e.target.checked });
    console.log(e.target.checked);
  };

  setFilterData(e) {
    this.setState({ showVerifiedOnly: e.target.checked });
  }
  setFilterCategoryData(id) {
    this.setState({ category_id: id });
    this.setState({ category_id: id }, () => {
      console.log(this.state.category_id, "category_id");
      this.getExplore();
    });
  }

  array = [];
  setChainData(e) {
    console.log(e.target.checked);
    if (e.target.checked) {
      this.array.push(e.target.name);
      this.setState({ chain: this.array });
    } else {
      this.array = this.array.filter(function (value, index, arr) {
        return value != e.target.name;
      });

      this.setState({ chain: this.array });
    }
    console.log(this.state.chain);
  }

  getExplore() {
    const api = new Api();
    //api.startLoader()
    this.setState({loader: true});
    const obj = {
      // status: this.state.status,
      // minprice: this.state.minprice,
      // maxprice: this.state.maxPrice,
      chain: this.state.chain,
      // showverifiedonly: this.state.showVerifiedOnly,
      pagenumber: this.state.pageNumber,
      pagesize: this.state.pageSize,
      category_id: this.state.category_id,
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: obj,
    };
    
    //  if (this.timeout) clearTimeout(this.timeout);
    // this.timeout = setTimeout(() => {
    api
      .post("filtered_collections/", obj)
      .then((response) => {
        let result = [];
        //result.push(this.state.exploreArry);
        // result.push(response.data);
        this.setState({ exploreArry: response.data });
        this.setState({loader: false});
      })
      .catch((err) => console.log(err));
   // },1000000);

    this.explorrerCollection2(1);
  }

 async getTopcollection(collectionName) {
    const api = new Api();
    this.setState({loader1: true});
    var parameter = "";
    if (collectionName != null) {
      parameter = { collection_name: collectionName };
    }
     // if (this.timeout) clearTimeout(this.timeout);
   
    api
      .get("get_top_collections/", parameter)
      .then((response) => {
        this.setState({ topCollectionArry: response.data });
        this.setState({loader1: false});
        console.log(response.data);
      })
      .catch((err) => console.log(err));
  }

  getSummary() {
    const api = new Api();
    var parameter = "";
    api
      .get("get_summary/", parameter)
      .then((response) => {
        let da = [];
        da.push({
          value:
            response.data.collections >= 1000
              ? Math.round(response.data.collections / 1000) + "k+"
              : response.data.collections,
          name: "Collections",
        });
        da.push({
          value:
            response.data.assets >= 1000
              ? Math.round(response.data.assets / 1000) + "k+"
              : response.data.assets,
          name: "Artwork",
        });
        da.push({
          value:
            response.data.users >= 1000
              ? Math.round(response.data.users / 1000) + "k+"
              : response.data.users,
          name: "Artist",
        });
        this.setState({ summaryArry: da });
      })
      .catch((err) => console.log(err));
  }

  getPredefineCategory() {
    const api = new Api();
    var parameter = "";
    api
      .get("get_categories/", parameter)
      .then((response) => {
        let catData = [];
        this.setState({ categoryArray: response.data });
      })
      .catch((err) => console.log(err));
  }

  getWorkingdays(filter) {
    const api = new Api();
    var parameter = "";
    console.log(filter);
    this.setState({ topCollectionStatus: filter.replace("-", " ") });
    api
      .get(
        "get_top_collection/?filter_item=collection&filter_duration=" + filter,
        parameter
      )
      .then((response) => {
        this.setState({ topCollectionArry: response.data });
      })
      .catch((err) => console.log(err));
    console.log("My function called");
  }

  getNftCollection() {
    const api = new Api();
    var parameter = "";
    this.setState({loader3: true});

    api
      .get("get_featured_nft_collection/?pagesize=10&pagenumber=1", parameter)
      .then((response) => {
        this.setState({ featureNftArry: response.data });
        this.setState({loader3: false});
      })
      .catch((err) => console.log(err));
  }

  async getNftAssetToken() {
    const api = new Api();
    this.setState({loader2: true});
    var parameter = "";

   // this.timeout1 = setTimeout(() => {
    api
      .get("get_top_assets/?count=5", parameter)
      .then((response) => {
        this.setState({ assetCollectionArry: response.data });
        this.setState({loader2: false});
        //clearTimeout(this.timeout1);
      })
      .catch((err) => console.log(err));
     //},100000);
  }

  explorrerCollection() {
    document.body.classList.toggle("filterActive", "filter");
    document
      .querySelector(".filter-button")
      .classList.toggle("active", "filter");
    document
      .querySelector(".filter-list-box-wrap")
      .classList.toggle("filter-open", "filter");
  }
  explorrerCollection2(flag) {
    document.body.classList.remove("filterActive");
    document.querySelector(".filter-button").classList.remove("active");
    document
      .querySelector(".filter-list-box-wrap")
      .classList.remove("filter-open");
    if (flag == 2) {
      //var x = document.getElementsByClassName("verifiedCheck");
      this.refs["verifiedCheck"].checked = false; //this.refs['verifiedCheck'].checked;
      this.refs["Ethereum"].checked = false; //this.refs['ethereumCheck'].checked;
      this.refs["Polygon"].checked = false; //this.refs['polygonCheck'].checked;
      this.refs["Solana"].checked = false; //this.refs['solanaCheck'].checked;
      //x.checked = false;

      this.applyFilter = false;
      this.setState(
        {
          status: false,
          minprice: "",
          maxPrice: "",
          chain: [],
          category_id: null,
          showVerifiedOnly: false,
        },
        console.log("clear")
      );
    }
  }

  clearAll() {
    this.refs["verifiedCheck"].checked = false; //this.refs['verifiedCheck'].checked;
    this.refs["Ethereum"].checked = false; //this.refs['ethereumCheck'].checked;
    this.refs["Polygon"].checked = false; //this.refs['polygonCheck'].checked;
    this.refs["Solana"].checked = false; //this.refs['solanaCheck'].checked;

    this.applyFilter = false;
    this.setState(
      {
        status: false,
        minprice: "",
        maxPrice: "",
        chain: [],
        category_id: null,
        showVerifiedOnly: false,
        isBuyNow: false,
      },
      console.log("clear")
    );
  }

  removeChain(flag) {
    console.log(this.state.chain[flag]);
    this.refs[this.state.chain[flag]].checked = false;
    var name = this.state.chain[flag];
    this.array = this.array.filter(function (value, index, arr) {
      return value != name;
    });
    this.setState({ chain: this.array });
  }
  removeShowOnly() {
    this.refs["verifiedCheck"].checked = false;
    this.setState(
      {
        showVerifiedOnly: false,
      },
      console.log("clear")
    );
  }
  removePrice() {
    this.setState(
      {
        minprice: "",
        maxPrice: "",
      },
      console.log("clear")
    );
  }

  getFormattePrice(price) {
    if (price) return new CommonHelper().formatPrice(price, 8);

    return "";
  }

  async getMarketItem(tokenId) {
    var contract = await this.getContract();
    return contract.getMarketItemByTokenId(tokenId).then(
      (marketItem) => {
        if (marketItem == null) {
          //todo: decide what to do if marketItem not found
        }
        console.log(marketItem);
        return marketItem;
      },
      (err) => {
        new ErrorHandler().processEtherMessage(err);
      }
    );
  }

  async getContract() {
    const web3Modal = new Web3Modal();
    const connection = await web3Modal.connect();
    const provider = new ethers.providers.Web3Provider(connection);
    const signer = provider.getSigner();
    const contract = new ethers.Contract(
      this.state.chainConfig.NFT_MARKETPLACE_ADDRESS,
      NFTMarket.abi,
      signer
    );

    return contract;
  }

  render = () => {
    if (this.state.isBuyNow) {
      return <Navigate to={"./login"} />;
    }
    return (
      <>
        <div className="home-page">
          <section className="banner">
            <div className="container">
              <div className="left">
                <h2>Discover & collect Digital Art NFTs </h2>
                <p>
                  Digital marketplace for crypto collectibles and non-fungible
                  tokens (NFTs). Buy, Sell, and discover exclusive digital
                  assets.
                </p>
                <Link to="/ExploreCollections" className="button">
                  Explore Now
                </Link>
                <ul className="portfolio">
                  {this.state.summaryArry.map((summarys, index) => (
                    <li key={index}>
                      <h2>{summarys.value}</h2>
                      <p>{summarys.name}</p>
                    </li>
                  ))}
                </ul>
              </div>
              {/* LEFT END */}
              <div className="right">
                {/* <div className="live-tag">
                  <img src="../images/live-aux.png" alt="Live Aux" />
                </div> */}
                 {!this.state.loader2 ? (
                  <Swiper effect={"cards"} grabCursor={true} centeredSlides={false} modules={[EffectCards]} className="bannerSlider" >
                    {this.state.assetCollectionArry
                      .slice(0, 5)
                      .map((assetActivity, i) => (
                        <SwiperSlide key={i}>
                          <div className="card-bg">
                            <Link to={"nftDetails?assetId=" + assetActivity.id}>
                              <img
                                src={assetActivity.asset_image}
                                alt="Card Img"
                              />
                            </Link>
                          </div>
                          <div className="card-header">
                            <h4>{assetActivity.asset_name}</h4>
                            <div className="artist">
                              <div className="img-box">
                                <img
                                  src={
                                    assetActivity.profile_image
                                      ? assetActivity.profile_image
                                      : "../images/default_image.png"
                                  }
                                  alt="Artist"
                                />
                              </div>
                              <div className="name">{assetActivity.username}</div>
                            </div>
                          </div>
                          <div className="card-footer">
                            <div className="current-bid">
                              <div className="title">Current Bid</div>
                              <div className="bid-price">
                                <div className="img-box">
                                  <img
                                    src={assetActivity.currency_image}
                                    alt="Coin"
                                  />
                                  {/* <img src="../images/eth.png" alt="Coin" /> */}
                                </div>
                                <div className="value">
                                  {assetActivity.price} {assetActivity.currency}
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                ) :  [1].map(loading =>(
                    <>
                      <div className="skeleton-itemshome" key={loading}>
                      <SkeletonProduct />
                      </div>
                    </>
                  ))}
              </div>
            </div>
            <div className="dots">
              <img src="../images/banner-dots.png" alt="dota" />
            </div>
          </section>
          {/* BANNER END */}
          <section className="features">
            <div className="container">
              <div className="section-title">
                <h2>The amazing NFT art of the world here</h2>
              </div>
              <div className="media">
                <div className="media-img">
                  <img src="../images/fast.png" alt="Icon" />
                </div>
                <div className="media-body">
                  <h4>Fast Transaction</h4>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aliquam etiam viverra tellus imperdiet.
                  </p>
                </div>
              </div>
              <div className="media">
                <div className="media-img">
                  <img src="../images/growth.png" alt="Icon" />
                </div>
                <div className="media-body">
                  <h4>Growth Transaction</h4>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aliquam etiam viverra tellus
                  </p>
                </div>
              </div>
            </div>
          </section>
          {/* FEATURES END */}
          <section className="top-collection">
            <div className="container">
              <ul className="high-bid-mob">
                {this.state.assetCollectionArry
                  .slice(0, 3)
                  .map((assetCollections, i) => (
                    <li className="high-bid" key={i}>
                      <div className="card-img">
                        {/* <a href={'NftDetails/?assetId='+assetCollections.id}>  */}
                        <Link to={"NftDetails/?assetId=" + assetCollections.id}>
                          <img src={assetCollections.asset_image} alt="card" />
                        </Link>
                        {/* </a> */}
                      </div>
                      <div className="card-body">
                        <div className="media">
                          <div className="media-img">
                            <Link
                              to={
                                "../UserProfile?account=" +
                                assetCollections.account
                              }
                            >
                              <img
                                src={
                                  assetCollections.profile_image
                                    ? assetCollections.profile_image
                                    : "../images/default_image.png"
                                }
                                alt="artist"
                              />
                            </Link>
                          </div>
                          <div className="media-body">
                            <h4>{assetCollections.username}</h4>
                            <p>{assetCollections.count} in the stock</p>
                          </div>
                        </div>
                        <div className="bid-price">
                          <p>Highest Bid</p>
                          <div className="media">
                            <div className="media-img">
                              <img
                                src={assetCollections.currency_image}
                                alt="icon"
                              />
                            </div>
                            <div className="media-body">
                              {assetCollections.price}{" "}
                              {assetCollections.currency}
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
                {/* LI END */}
                {/* <li className="high-bid">
                  <div className="card-img">
                    <img src="../images/card4.png" alt="card" />
                  </div>
                  <div className="card-body">
                    <div className="media">
                      <div className="media-img">
                        <img src="../images/artist1.png" alt="artist" />
                      </div>
                      <div className="media-body">
                        <h4>The Futr Abstr</h4>
                        <p>20 in the stock</p>
                      </div>
                    </div>
                    <div className="bid-price">
                      <p>Highest Bid</p>
                      <div className="media">
                        <div className="media-img">
                          <img src="../images/eth-green.png" alt="icon" />
                        </div>
                        <div className="media-body">0.30 ETH</div>
                      </div>
                    </div>
                  </div>
                </li> */}
                {/* LI END */}
                {/* <li className="high-bid">
                  <div className="card-img">
                    <img src="../images/card4.png" alt="card" />
                  </div>
                  <div className="card-body">
                    <div className="media">
                      <div className="media-img">
                        <img src="../images/artist1.png" alt="artist" />
                      </div>
                      <div className="media-body">
                        <h4>The Futr Abstr</h4>
                        <p>10 in the stock</p>
                      </div>
                    </div>
                    <div className="bid-price">
                      <p>Highest Bid</p>
                      <div className="media">
                        <div className="media-img">
                          <img src="../images/eth-green.png" alt="icon" />
                        </div>
                        <div className="media-body">0.25 ETH</div>
                      </div>
                    </div>
                  </div>
                </li> */}
                {/* LI END */}
              </ul>
              
              <div className="high-bid">
              {!this.state.loader2 ? (
              this.state.assetCollectionArry
                .slice(1, 2)
                .map((assetCollections, i) => (
                  <div className="high-bid__aside">
                    <div className="card-img">
                      <Link to={"nftDetails?assetId=" + assetCollections.id}>
                        <img src={assetCollections.asset_image} alt="card" />
                      </Link>
                    </div>
                    <div className="card-body">
                      <div className="media">
                        <div className="media-img">
                          <Link
                            to={
                              "../UserProfile?account=" +
                              assetCollections.account
                            }
                          >
                            <img
                              src={
                                assetCollections.profile_image
                                  ? assetCollections.profile_image
                                  : "../images/default_image.png"
                              }
                              alt="artist"
                            />
                          </Link>
                        </div>
                        <div className="media-body">
                          <h4>{assetCollections.username}</h4>
                          <p>{assetCollections.count} in the stock</p>
                        </div>
                      </div>
                      <div className="bid-price">
                        {/* <p>Highest Bid</p> */}
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                        <div className="media">
                          <div className="media-img">
                            <img
                              src={assetCollections.currency_image}
                              alt="icon"
                            />
                          </div>
                          <div className="media-body">
                            {assetCollections.price} {assetCollections.currency}
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                ))
                ) :  [1].map(loading =>(
                  <>
                    <div className="skeleton-items" key={loading}>
                    <SkeletonProduct />
                    </div>
                  </>
                ))}
                </div>


              {/* {this.state.assetCollectionArry.slice(1, 2).length == 0 ? (
                <div className="high-bid">
                  <div className="card-img"></div>
                  <div className="card-body">
                    <div className="media">
                      <div className="media-img"></div>
                      <div className="media-body">
                        <h4></h4>
                        <p></p>
                      </div>
                    </div>
                    <div className="bid-price"> 
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                      <div className="media">
                        <div className="media-img"></div>
                        <div className="media-body"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )} */}
              
              {/* HIGH BID */}
              <div className="high-bid-list">
              {!this.state.loader2 ? (
                <ul>
                  {this.state.assetCollectionArry
                    .slice(2, 5)
                    .map((assetCollections, i) => (
                      <li className="media" key={i}>
                        <div className="media-img">
                          <Link
                            to={"nftDetails?assetId=" + assetCollections.id}
                          >
                            <img
                              src={assetCollections.asset_thumbnail}
                              alt="Img"
                            />
                          </Link>
                        </div>
                        <div className="card-body">
                          <h4>{assetCollections.asset_name}</h4>
                          <div className="price-block">
                            <div className="artist-img">
                              <Link
                                to={
                                  "../UserProfile?account=" +
                                  assetCollections.account
                                }
                              >
                                <img
                                  src={
                                    assetCollections.profile_image
                                      ? assetCollections.profile_image
                                      : "../images/default_image.png"
                                  }
                                  alt="artist"
                                />
                              </Link>
                            </div>
                            <div className="price">
                              <div className="icon">
                                <img
                                  src={assetCollections.currency_image}
                                  alt="eth"
                                />
                              </div>
                              <div className="value">
                                {assetCollections.price}{" "}
                                {assetCollections.currency}
                              </div>
                            </div>
                            <div className="bid-count">
                              {assetCollections.count}
                            </div>
                          </div>
                          <Link
                            to={"nftDetails?assetId=" + assetCollections.id}
                          >
                            <button className="button">Buy Now</button>
                          </Link>
                        </div>
                      </li>
                    ))}
                  {/* LI END */}
                </ul>
                ) :  [1,2,3].map(loading =>(
                  <>
                    <div className="skeleton-items" key={loading}>
                    <SkeletonProduct />
                    </div>
                  </>
                ))}

              </div>
              {/* BID LIST END */}
              <div className="collection-list">
                <h2>Top Collections </h2>
                {/* <Tippy
                content={
                  <ul>
                  {this.state.topCollectioDays.slice(0, 1).map((collectiondays,i) =>
                    <li>
                      <button type="button" onClick={() => this.getWorkingdays('24-hours')}>last {collectiondays} hours</button>
                    </li>
                    )}
                     {this.state.topCollectioDays.slice(1, 3).map((collectiondays,i) =>
                    <li>
                      <button type="button" onClick={() => this.getWorkingdays(collectiondays+'-days')}>last {collectiondays} days</button>
                    </li>
                    )}
                    
                  </ul>
                }
                animation="fade"
                arrow={false}
                trigger="click"
                interactive="true"
                placement={"bottom"}
                appendTo="parent"
                className="title-dropdown"
              >
                <button type="button" className="dropdown-title">
                  last {this.state.topCollectionStatus}{" "}
                  <i className="material-icons-outlined">expand_more</i>
                </button>
               
              </Tippy> */}
               {!this.state.loader1 ? (
                <ul>
                  {this.state.topCollectionArry.map((topcollections, i) => (
                    <li key={i}>
                      <Link
                        to={
                          "/CollectionDetails/?collectionId=" +
                          topcollections.collection_id
                        }
                        className="media"
                      >
                        <span className="number">{i + 1}</span>
                        <div className="media-img">
                          <div className="verify">
                            {topcollections.isVerified == true ||
                            topcollections.is_verified == true ? (
                              <img src="../images/verify.png" alt="varify" />
                            ) : (
                              false
                            )}
                          </div>
                          <img
                            src={
                              topcollections.collection_image
                                ? topcollections.collection_image
                                : "../images/card1.png"
                            }
                            alt="card"
                          />
                        </div>
                        <div className="media-body">
                          <h4>{topcollections.collection_name}</h4>
                          <div className="price">
                            <div className="img-box">
                              <img
                                src={topcollections.currency_image}
                                alt="icon"
                              />
                            </div>
                            <div className="value">
                              {this.getFormattePrice(
                                topcollections.total_amount
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="price-change gain">
                          {topcollections.price_update}
                        </div>
                      </Link>
                    </li>
                  ))}

                  {/* LI END */}
                </ul>
                ) :  [1,2,3,4,5].map(loading =>(
                  <>
                    <div className="skeleton-items" key={loading}>
                    <SkeletonProduct />
                    </div>
                  </>
                ))}

              </div>
              <div className="show-more">
                <Link to="./ExploreNfts" className="button purple-outline">
                  Show me more
                </Link>
              </div>
            </div>
            
          </section>
          {/* TOP COLLECTION END */}
          <section className="featured-nft">
            <div className="container">
              <div className="section-title">
                <h2>Collection Featured NFTs</h2>
              </div>
              {!this.state.loader3 ? (
              <ul className="nft-list">
                {this.state.featureNftArry
                  .slice(0, 3)
                  .map((featureNftCollection, index) => (
                    <li key={index}>
                      <div className="img-group">
                        <div className="left-img">
                          {featureNftCollection.assets
                            .slice(0, 1)
                            .map((featureNftImg, i) => (
                              <Link
                                to={
                                  "NftDetails/?assetId=" +
                                  featureNftImg.asset_id
                                }
                              >
                                <img src={featureNftImg.image_loc} alt="Img" />
                              </Link>
                            ))}
                        </div>
                        <ul className="right-img">
                          {featureNftCollection.assets
                            .slice(1, 4)
                            .map((featureNftImg, i) => (
                              <li key={i}>
                                <Link
                                  to={
                                    "NftDetails/?assetId=" +
                                    featureNftImg.asset_id
                                  }
                                >
                                  <img
                                    src={featureNftImg.image_thumbnail}
                                    alt="Img"
                                  />
                                </Link>
                              </li>
                            ))}
                        </ul>
                      </div>
                      <div className="title-block">
                        <h2>{featureNftCollection.collection_name}</h2>
                        <div className="artist">
                          <div className="img-box">
                            {/* <Link
                                  to={"../UserProfile?account=" + featureNftCollection.account
                                  }
                                > */}
                            <img
                              src={
                                featureNftCollection.user_profile_pic
                                  ? featureNftCollection.user_profile_pic
                                  : "../images/default_image.png"
                              }
                              alt="Artist"
                            />
                            {/* </Link> */}
                          </div>
                          <div className="name">
                            <Link
                              className="link font-size-18"
                              to={
                                "../UserProfile/?account=" +
                                featureNftCollection.account
                              }
                            >
                            {featureNftCollection.created_by}
                            </Link>
                          </div>
                        </div>
                        {/* <a href="/" className="button outline total-item">
                          {featureNftCollection.num_of_asset}
                        </a> */}
                      </div>
                    </li>
                  ))}
              </ul>
              ) :  [1,2,3,].map(loading =>(
                  <>
                    <div className="skeleton-items" key={loading}>
                    <SkeletonProduct />
                    </div>
                  </>
                ))}
            </div>
          </section>
          {/* FEATURED END */}
          <section className="sell-nft">
            <div className="container">
              <div className="img-box">
                <img src="../images/signup.png" alt="Img" />
              </div>
              <div className="content-box">
                <div className="section-title">
                  <h2>
                    Create and <br /> sell your NFTs
                  </h2>
                </div>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Facilisi ac phasellus placerat a pellentesque tellus sed
                  egestas. Et tristique dictum sit tristique sed non. Lacinia
                  lorem id consectetur pretium diam ut. Pellentesque eu sit
                  blandit fringilla risus faucibus.
                </p>
                <Link to="../Login" className="button">
                  Sign Up Now
                </Link>
              </div>
            </div>
          </section>
          {/* SELL NFT END */}
          <section className="discover-nft">
            <div className="container">
              <div className="section-title">
                <h2>Discover more Collections</h2>
                <button
                  className="filter-button"
                  onClick={() => this.state.setFilter(!this.state.filter)}
                >
                  <div className="img-box">
                    <i className="material-icons-outlined">filter_list</i>
                  </div>
                  <span>Filters</span>
                </button>
              </div>
              <div className="filter-wrap">
                <div className="filter-wrap__aside">
                  {/* <Scrollbars className="custmScrollbar scrollbar-horizontal" > */}
                  <ul className="filter-list">
                    <li key="1">
                      <a
                        className={
                          this.state.category_id == null ? "active" : ""
                        }
                        onClick={() => this.setFilterCategoryData(null)}
                      >
                        All Categories
                      </a>
                    </li>
                    {this.state.categoryArray.map((data, i) => (
                      <li key={i}>
                        <a
                          className={
                            this.state.category_id == data.id ? "active" : ""
                          }
                          onClick={() => this.setFilterCategoryData(data.id)}
                        >
                          {data.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                {/* <button
                  className="filter-button desk-only active"
                  onClick={() => this.explorrerCollection()}
                >
                  <div className="img-box">
                    <i className="material-icons-outlined">filter_list</i>
                  </div>
                  <span>All Filters</span>
                </button> */}
              </div>
              <div className="filter-list-box-wrap d-inline-block">
                {!this.state.loader ? (
                  this.state.exploreArry.collections?.length > 0  ?
                  <ul className="explore-nfts">
                    {this.state.exploreArry.collections?.map(
                      (explores, index) => (
                        <li key={index}>
                          <Link
                            to={
                              "CollectionDetails/?collectionId=" +
                              explores.collection_id
                            }
                            className="card"
                          >
                            <div className="card-img">
                              <img
                                src={
                                  explores.collection_image
                                    ? explores.collection_image
                                    : "../images/card1.png"
                                }
                                alt="discover"
                              />
                            </div>
                            <div className="card-body">
                              <div className="artist-block">
                                <div className="media">
                                  <div className="media-img">
                                    <img
                                      src={
                                        explores.user_profile_image
                                          ? explores.user_profile_image
                                          : "../images/default_image.png"
                                      }
                                      alt="artist block"
                                    />
                                  </div>
                                  <div className="media-body">
                                  <h4>{explores.collection_name} <img src="../images/verify.png" alt="Verify" /></h4>
                                    {/* <h4>
                                      {explores.created_by}
                                      {<div className="img-box">
                                      {explores.user_verified == false ? (
                                        <img
                                          src="../images/verify.png"
                                          alt="verify"
                                        />
                                      ) : (
                                        true
                                      )}
                                    </div>}
                                    </h4> */}
                                    {/* <span title={explores.collection_name}>
                                      <label
                                        style={{
                                          width: 120 + "px",
                                          whiteSpace: "nowrap",
                                          overflow: " hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {explores.collection_name}
                                      </label>
                                    </span> */}
                                  </div>
                                  {/* <div className="bid-count">
                                  {index} of{" "}
                                  {this.state.exploreArry?.totalRecords}
                                </div> */}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                      )
                    )}
                  </ul>
                  :
                  <>
                    <div className="no-items"> 
                      <span>No Collections</span>
                    </div>
                  </>
                ) :  [1, 2, 3, 4,5,6,7,8].map(loading =>(
                  <>
                    <div className="skeleton-items" key={loading}>
                    <SkeletonProduct />
                    </div>
                  </>
                ))}
              </div>
              {this.state.exploreArry.collections?.length > 0 ? (
                <div className="button-wrap">
                  <Link
                    to="/ExploreCollections"
                    className="button purple-outline"
                  >
                    More Collections
                  </Link>
                </div>
              ) : (
                <></>
              )}
            </div>
          </section>
        </div>
      </>
    );
  };
}
//export default Home;
